import { render, staticRenderFns } from "./DocumentManager.vue?vue&type=template&id=37922b0a"
import script from "./DocumentManager.vue?vue&type=script&lang=js"
export * from "./DocumentManager.vue?vue&type=script&lang=js"
import style0 from "./DocumentManager.vue?vue&type=style&index=0&id=37922b0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports